import React from 'react';
import { Typography, Tabs, Tab, Box } from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import { connect } from 'redux-zero/react';
import actions from '../../actions';
import BankReceipts from './BankReceipts';
import BankPayments from './BankPayments';
import CashReceipts from './CashReceipts';
import CashPayments from './CashPayments';
import JournalVouchers from './JournalVouchers';
import JVTemplates from './JVTemplates';

// URL path of each tab, in tab order
export const transactionTabs = [
    { label: 'Bank Receipts', path: 'bankreceipts' },
    { label: 'Bank Payments', path: 'bankpayments' },
    { label: 'Cash Receipts', path: 'cashreceipts' },
    { label: 'Cash Payments', path: 'cashpayments' },
    { label: 'Journal Vouchers', path: 'journalvouchers' },
    { label: 'JV Templates', path: 'jvtemplates' }
];

const mapToProps = ({ selectedSociety }) => ({ selectedSociety });

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

function Transactions({ selectedSociety, setSelectedSociety }) {
    const history = useHistory();
    const { tab } = useParams();
    const value = Math.max(transactionTabs.findIndex(x => x.path === tab), 0);

    function handleChange(event, newValue) {
        history.push('/transactions/' + transactionTabs[newValue].path);
    }

    return (
        <>
            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                {transactionTabs.map(x => <Tab key={x.path} label={x.label} />)}
            </Tabs>
            <TabPanel value={value} index={0}>
                <BankReceipts />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <BankPayments />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <CashReceipts />
            </TabPanel>
            <TabPanel value={value} index={3}>
                <CashPayments />
            </TabPanel>
            <TabPanel value={value} index={4}>
                <JournalVouchers />
            </TabPanel>
            <TabPanel value={value} index={5}>
                <JVTemplates />
            </TabPanel>
        </>
    );
}

export default connect(mapToProps, actions)(Transactions);